import React from 'react';
import { hot } from 'react-hot-loader';
import { translate } from '../../utils/locale';
import s from './Price.scss';

const Price = ({ price = {}, setup = {}, soldOut = false, product = false, plp = false, cart = false }) => {
	const isOnSale = price.showAsOnSale || price.priceAsNumber !== price.priceBeforeDiscountAsNumber;

	if (soldOut && product) return <span className={[s.price, s.price__soldOutProduct].join(' ')}><s>{ price.priceBeforeDiscount !== price.price ? price.priceBeforeDiscount : price.price }</s></span>;
	if (soldOut) {
		return (
			<span className={[s.price, s.price__soldOut].join(' ')}>
				<span>{ soldOut }</span>
			</span>
		);
	}
	if (product) {
		return (
			<span className={[s.price, s.price__product].join(' ')}>
				{
					isOnSale ? (
						<>
							<s className={s.price_oldPrice}>{ price.priceBeforeDiscount }</s>
							<span className={s.price_discount}>{ `${price.discountPercent || Math.round((price.priceAsNumber / price.priceBeforeDiscountAsNumber) * 100)}% ${translate(setup, 'priceOff')}` }</span>
							<span className={s.price_sale}>{ price.price }</span>
						</>
					) : price.price
				}
			</span>
		);
	}
	return (
		<span className={[s.price, cart ? s.price__cart : null, plp ? s.price__plp : null].join(' ')}>
			{ isOnSale ? <><s className={s.price_oldPrice}>{ price.priceBeforeDiscount }</s> <span className={s.price_sale}>{price.price}</span></> : price.price }
		</span>
	);
};

export default hot(module)(Price);
